/* Astra 17/10/2026 — i video YouTube nelle descrizioni prodotto si guardano DENTRO la scheda.
   Il link-immagine «Guarda il VIDEO» portava fuori dal negozio, su YouTube. Qui diventa un riquadro
   con l'anteprima del video e il tasto play: il player (youtube-nocookie) si carica solo al clic,
   così la pagina non pesa di più e nessun cookie parte prima che il cliente lo chieda.
   Ritorno: togliere il tag script di questo file da layout/theme.liquid. */
(function () {
  function idDa(url) {
    var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{11})/);
    return m ? m[1] : null;
  }
  function trasforma(a) {
    var id = idDa(a.href);
    if (!id || a.dataset.astraVideo) return;
    a.dataset.astraVideo = '1';
    var box = document.createElement('div');
    box.className = 'astra-video';
    box.innerHTML =
      '<button type="button" class="astra-video__play" aria-label="Guarda il video">' +
      '<img src="https://i.ytimg.com/vi/' + id + '/hqdefault.jpg" alt="Video: ' + (a.title || 'guarda il video') + '" loading="lazy" width="480" height="360">' +
      '<span class="astra-video__icona" aria-hidden="true"></span></button>';
    box.querySelector('button').addEventListener('click', function () {
      box.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id +
        '?autoplay=1&rel=0" title="' + (a.title || 'Video') + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    });
    var blocco = a.closest('p') || a;
    blocco.replaceWith(box);
  }
  function avvia() {
    document.querySelectorAll('.product-description a[href*="youtu"]').forEach(trasforma);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
